"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneTrustGetUserResponse = exports.OneTrustUserEmails = exports.OneTrustUserEmail = exports.OneTrustUserGroup = exports.OneTrustUserMetadata = void 0;
const t = __importStar(require("io-ts"));
exports.OneTrustUserMetadata = t.type({
    /** When the user was created */
    created: t.string,
    /** When the user was modified */
    lastModified: t.string,
    /** The URI for accessing information about the user */
    location: t.string,
    /** The resource type */
    resourceType: t.literal('User'),
});
const OneTrustUserName = t.partial({
    /** The user's family name */
    familyName: t.string,
    /** The user's given name */
    givenName: t.string,
});
exports.OneTrustUserGroup = t.type({
    /** The user group's identification */
    value: t.string,
    /** The user group's display name */
    display: t.string,
});
const OneTrustUserGroups = t.array(exports.OneTrustUserGroup);
exports.OneTrustUserEmail = t.type({
    /** The email value */
    value: t.string,
    /** The email display name */
    display: t.string,
    /** Whether this is the primary email */
    primary: t.boolean,
    /** The email type */
    type: t.union([t.string, t.literal('work')]),
});
exports.OneTrustUserEmails = t.array(exports.OneTrustUserEmail);
/**
 * The response type of the OneTrust GetUser endpoint
 * ref: https://developer.onetrust.com/onetrust/reference/getuserusingget
 */
exports.OneTrustGetUserResponse = t.type({
    /** ID of the user. */
    id: t.string,
    /** External ID of the user. */
    externalId: t.union([t.string, t.null]),
    /** Metadata of the user. */
    meta: exports.OneTrustUserMetadata,
    /** Schemas of the user */
    schemas: t.array(t.string),
    /** Name or email of the user */
    userName: t.string,
    /** Full name of the user */
    name: OneTrustUserName,
    /** Type of the user */
    userType: t.union([t.literal('Internal'), t.literal('External')]),
    /** Flag to check if the user is an active user or not. */
    active: t.boolean,
    /** The groups that the user belongs to */
    groups: OneTrustUserGroups,
    /** The emails of the user */
    emails: exports.OneTrustUserEmails,
    /** The roles of the user */
    roles: t.array(t.string),
    /** The title of the user */
    title: t.union([t.string, t.null]),
});
//# sourceMappingURL=getUser.js.map